var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneOtpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 79,
    r: 79,
    fill: "#008DFF",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.6981 138.336H56.8811C54.5257 138.336 52.2667 137.394 50.6012 135.718C48.9357 134.042 48 131.769 48 129.398V34.9379C48 32.5674 48.9357 30.294 50.6012 28.6178C52.2667 26.9417 54.5257 26 56.8811 26H98.6981C101.054 26 103.312 26.9417 104.978 28.6178C106.644 30.294 107.579 32.5674 107.579 34.9379V129.373C107.583 130.549 107.355 131.714 106.91 132.801C106.466 133.888 105.812 134.877 104.987 135.709C104.162 136.542 103.182 137.203 102.103 137.653C101.023 138.104 99.8666 138.336 98.6981 138.336Z",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.63 39.8542H48",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.63 122H48",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2993 34H77.4976",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34H85.2583",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4981 134.13C79.6001 134.13 81.3042 132.415 81.3042 130.3C81.3042 128.184 79.6001 126.469 77.4981 126.469C75.396 126.469 73.6919 128.184 73.6919 130.3C73.6919 132.415 75.396 134.13 77.4981 134.13Z",
    stroke: "#008DFF",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.607 58.6553H65.5703C64.7977 58.6553 64.0567 58.9642 63.5104 59.5139C62.9641 60.0637 62.6572 60.8094 62.6572 61.587V84.1263C62.6572 84.9038 62.9641 85.6495 63.5104 86.1993C64.0567 86.7491 64.7977 87.0579 65.5703 87.0579H67.5671C67.6258 87.1491 67.6941 87.2337 67.7707 87.3101L70.5977 90.1551C70.7502 90.3134 70.9328 90.4392 71.1345 90.5251C71.3363 90.611 71.5532 90.6553 71.7723 90.6553C71.9914 90.6553 72.2082 90.611 72.41 90.5251C72.6118 90.4392 72.7943 90.3134 72.9469 90.1551L75.7738 87.3101C75.8482 87.2316 75.9163 87.1473 75.9774 87.0579H121.639C122.406 87.0496 123.139 86.7371 123.678 86.1882C124.218 85.6393 124.521 84.8984 124.521 84.1263V61.587C124.521 60.8094 124.214 60.0637 123.667 59.5139C123.121 58.9642 122.38 58.6553 121.607 58.6553Z",
    fill: "#75FB91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0525 75.4582C73.3499 75.4582 74.4017 74.3996 74.4017 73.0939C74.4017 71.7882 73.3499 70.7296 72.0525 70.7296C70.755 70.7296 69.7032 71.7882 69.7032 73.0939C69.7032 74.3996 70.755 75.4582 72.0525 75.4582Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4298 75.4582C83.7273 75.4582 84.7791 74.3996 84.7791 73.0939C84.7791 71.7882 83.7273 70.7296 82.4298 70.7296C81.1324 70.7296 80.0806 71.7882 80.0806 73.0939C80.0806 74.3996 81.1324 75.4582 82.4298 75.4582Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8053 75.4582C94.1028 75.4582 95.1546 74.3996 95.1546 73.0939C95.1546 71.7882 94.1028 70.7296 92.8053 70.7296C91.5079 70.7296 90.4561 71.7882 90.4561 73.0939C90.4561 74.3996 91.5079 75.4582 92.8053 75.4582Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.181 75.4582C104.478 75.4582 105.53 74.3996 105.53 73.0939C105.53 71.7882 104.478 70.7296 103.181 70.7296C101.883 70.7296 100.832 71.7882 100.832 73.0939C100.832 74.3996 101.883 75.4582 103.181 75.4582Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.556 75.4582C114.854 75.4582 115.906 74.3996 115.906 73.0939C115.906 71.7882 114.854 70.7296 113.556 70.7296C112.259 70.7296 111.207 71.7882 111.207 73.0939C111.207 74.3996 112.259 75.4582 113.556 75.4582Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOtpIcon);
export default __webpack_public_path__ + "static/media/phoneOtpIcon.02e939ec0d263d20e90ffb17b85dbbcb.svg";
export { ForwardRef as ReactComponent };